/* @flow */

import React from 'react';
import { connect } from 'react-redux';

import PopupLoadingViewComponent from 'components/loading/popup';

import ConfirmingTypeDialogViewComponent from './view';
import ConfirmingTypeForm from './model';

import { handleFormChange } from 'lib/forms';

type ConfirmingTypeDialogComponentProps = {
  handleCancel: () => void;
  handleCompanyTypeChange: () => void;
}

type ConfirmingTypeDialogComponentState = {
  constraints: any;
  errors: Map<string,?string>;
  form: ConfirmingTypeForm;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
}

class ConfirmingTypeDialogComponent extends React.Component<ConfirmingTypeDialogComponentProps, ConfirmingTypeDialogComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      form: null,
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {

      this.setState({
        form: new ConfirmingTypeForm(),
        isLoading: false
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleChange = (companyType: number) => {
    const form = this.state.form;
    form.confirmingType = companyType;
    this.setState(form);
  };
  submitForm = async () => {
    this.props.handleCompanyTypeChange(this.state.form.confirmingType);
  };

  render() {
    if (this.state.isLoading) {
      return (<PopupLoadingViewComponent />);
    }

    return (
      <ConfirmingTypeDialogViewComponent
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        handleCancel={this.props.handleCancel}
        handleChange={this.handleChange}
        submitForm={this.submitForm}
      />
    );
  }
}


export default connect()(ConfirmingTypeDialogComponent);
